function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var _require = require('./transaction-types'),
  SLIP_TYPE_NAMES = _require.SLIP_TYPE_NAMES;
var SLIP_TYPE_IDS = {};
for (var _i = 0, _Object$entries = Object.entries(SLIP_TYPE_NAMES); _i < _Object$entries.length; _i++) {
  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
    key = _Object$entries$_i[0],
    name = _Object$entries$_i[1];
  if (/^[0-9]+$/.test(key)) {
    SLIP_TYPE_IDS[name] = Number(key);
  }
}
function slipField(slip, camel, snake) {
  if (!slip) {
    return null;
  }
  if (slip[camel] != null && slip[camel] !== '') {
    return slip[camel];
  }
  if (slip[snake] != null && slip[snake] !== '') {
    return slip[snake];
  }
  return null;
}
function numericSlipType(type) {
  if (type == null || type === '') {
    return null;
  }
  if (typeof type === 'number' && Number.isFinite(type)) {
    return type;
  }
  if (typeof type === 'bigint') {
    return Number(type);
  }
  var asNumber = Number(type);
  if (Number.isFinite(asNumber) && String(asNumber) === String(type).trim()) {
    return asNumber;
  }
  if (SLIP_TYPE_IDS[type] != null) {
    return SLIP_TYPE_IDS[type];
  }
  return null;
}
function slipTypeId(slip) {
  return numericSlipType(slipField(slip, 'type', 'slip_type'));
}
function isBoundSlip(slip) {
  return slipTypeId(slip) === SLIP_TYPE_IDS.Bound;
}
function isCustodySlip(slip) {
  var type = slipTypeId(slip);
  return type === SLIP_TYPE_IDS.Normal || type === SLIP_TYPE_IDS.ATR;
}
function slipAmount(slip) {
  if (slip == null) {
    return 0n;
  }
  try {
    var _slipField;
    return BigInt((_slipField = slipField(slip, 'amount', 'amount')) !== null && _slipField !== void 0 ? _slipField : 0);
  } catch (err) {
    return 0n;
  }
}
function isNftTuple(slips, index) {
  if (!slips || index + 2 >= slips.length) {
    return false;
  }
  return isBoundSlip(slips[index]) && isCustodySlip(slips[index + 1]) && isBoundSlip(slips[index + 2]);
}
function hexToBytes(hex) {
  var clean = String(hex || '').replace(/^0x/i, '');
  if (!/^[0-9a-fA-F]*$/.test(clean) || clean.length % 2 !== 0) {
    return null;
  }
  var bytes = new Uint8Array(clean.length / 2);
  for (var i = 0; i < bytes.length; i++) {
    bytes[i] = parseInt(clean.slice(i * 2, i * 2 + 2), 16);
  }
  return bytes;
}
function bytesToHex(bytes) {
  var hex = '';
  for (var i = 0; i < bytes.length; i++) {
    hex += bytes[i].toString(16).padStart(2, '0');
  }
  return hex;
}
function publicKeyToBytes(app, publicKey) {
  var key = String(publicKey || '').trim();
  if (!key) {
    return null;
  }
  if (/^[0-9a-fA-F]{66}$/.test(key)) {
    return hexToBytes(key);
  }
  try {
    var _app$crypto;
    if (app !== null && app !== void 0 && (_app$crypto = app.crypto) !== null && _app$crypto !== void 0 && _app$crypto.fromBase58) {
      var hex = app.crypto.fromBase58(key);
      var bytes = hexToBytes(hex);
      if ((bytes === null || bytes === void 0 ? void 0 : bytes.length) === 33) {
        return bytes;
      }
      if ((bytes === null || bytes === void 0 ? void 0 : bytes.length) === 34 && bytes[0] === 0) {
        return bytes.slice(1);
      }
    }
  } catch (err) {
    // not base58
  }
  return null;
}
function readUint64Be(bytes, offset) {
  var value = 0n;
  for (var i = 0; i < 8; i++) {
    value = (value << 8n) + BigInt(bytes[offset + i]);
  }
  return value;
}
function parseNftUuid(app, publicKey) {
  var bytes = publicKeyToBytes(app, publicKey);
  if (!bytes || bytes.length !== 33) {
    return {
      nftId: '',
      nftType: '',
      mintBlockId: '',
      mintTxOrdinal: '',
      mintSlipIndex: ''
    };
  }
  var typeBytes = bytes.slice(17);
  var end = typeBytes.length;
  while (end > 0 && typeBytes[end - 1] === 0) {
    end -= 1;
  }
  var nftType = '';
  try {
    nftType = new TextDecoder().decode(typeBytes.subarray(0, end)).replace(/\0+$/g, '');
  } catch (err) {
    nftType = '';
  }
  return {
    nftId: bytesToHex(bytes),
    nftType: nftType,
    mintBlockId: readUint64Be(bytes, 0).toString(),
    mintTxOrdinal: readUint64Be(bytes, 8).toString(),
    mintSlipIndex: String(bytes[16])
  };
}
function nolanFromNonBoundSlips() {
  var slips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var total = 0n;
  for (var i = 0; i < slips.length; i++) {
    if (isBoundSlip(slips[i])) {
      continue;
    }
    total += slipAmount(slips[i]);
  }
  return total;
}
function nftQuantityFromSlips() {
  var slips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var total = 0n;
  for (var i = 0; i + 2 < slips.length; i++) {
    if (!isNftTuple(slips, i)) {
      continue;
    }
    total += slipAmount(slips[i]);
    i += 2;
  }
  return total;
}
function groupSlips() {
  var slips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var groups = [];
  var i = 0;
  while (i < slips.length) {
    if (isNftTuple(slips, i)) {
      groups.push({
        kind: 'nft',
        slips: [slips[i], slips[i + 1], slips[i + 2]]
      });
      i += 3;
      continue;
    }
    groups.push({
      kind: 'slip',
      slips: [slips[i]]
    });
    i += 1;
  }
  return groups;
}
module.exports = {
  slipField: slipField,
  slipTypeId: slipTypeId,
  slipAmount: slipAmount,
  isBoundSlip: isBoundSlip,
  isNftTuple: isNftTuple,
  parseNftUuid: parseNftUuid,
  nolanFromNonBoundSlips: nolanFromNonBoundSlips,
  nftQuantityFromSlips: nftQuantityFromSlips,
  groupSlips: groupSlips
};